import axios from 'axios';

import { authHeader } from '../_helpers';
import { urlAPI } from './index';

// ruta API de la entidad
let API = 'api/modelo/';

// Exporta metodos
export const modeloService = {
    getAll,
    getxmarca,
    getById,
    putObject,
    postObject,
    deleteObject
};

// Lee todos los elementos
function getAll() {
    return axios.get(urlAPI + API, authHeader()).then(registro => {
        return registro.data;
    });
}

// Lee solo los elementos relacionados con el id de la entidad padre marca
function getxmarca(id) {
    return axios
        .get(urlAPI + API + 'marca/' + id, authHeader())
        .then(registro => {
            return registro.data;
        });
}

// Lee un solo elemento de la entidad
function getById(id) {
    return axios.get(urlAPI + API + id, authHeader()).then(registro => {
        return registro.data;
    });
}

// Post de la entidad
function postObject(obj) {
    // Copiar todas las propiedades menos id
    var modelo = {
        nombre: obj.nombre,
        marcaId: obj.marca.id,
        tipVehiculoId: obj.tipVehiculo.id,
        borrado: obj.borrado
    };
    return axios.post(urlAPI + API, modelo, authHeader()).then(registro => {
        // Completa nombre e id de la relacion en select
        registro.data.marca = {
            id: obj.marca.id,
            nombre: obj.marca.nombre
        };
        // Completa nombre e id de la relacion en select
        registro.data.tipVehiculo = {
            id: obj.tipVehiculo.id,
            nombre: obj.tipVehiculo.nombre
        };
        return registro.data;
    });
}

// put de la entidad
function putObject(obj) {
    // Copiar todas las propiedades
    var modelo = {
        id: obj.id,
        nombre: obj.nombre,
        marcaId: obj.marca.id,
        tipVehiculoId: obj.tipVehiculo.id,
        borrado: obj.borrado
    };
    return axios
        .put(urlAPI + API + modelo.id, modelo, authHeader())
        .then(registro => {
            // Completa nombre e id de la relacion en select
            registro.data.marca = {
                id: obj.marca.id,
                nombre: obj.marca.nombre
            };
            // Completa nombre e id de la relacion en select
            registro.data.tipVehiculo = {
                id: obj.tipVehiculo.id,
                nombre: obj.tipVehiculo.nombre
            };
            return registro.data;
        });
}

// delete de la entidad
function deleteObject(obj) {
    return axios.delete(urlAPI + API + obj, authHeader()).then(registro => {
        return registro.data;
    });
}
